import { render, staticRenderFns } from "./AdvertWeek.vue?vue&type=template&id=68fbf781&scoped=true"
import script from "./AdvertWeek.vue?vue&type=script&lang=js"
export * from "./AdvertWeek.vue?vue&type=script&lang=js"
import style0 from "./AdvertWeek.vue?vue&type=style&index=0&id=68fbf781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fbf781",
  null
  
)

export default component.exports